import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Container } from "@radix-ui/themes";

type ContainerWrapperProps = {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  maxWidth?: string;
};

export default function ContainerWrapper({
  children,
  className,
  style,
  maxWidth = "1700px",
}: ContainerWrapperProps) {
  return (
    <Container
      maxWidth={maxWidth}
      className={cn("px-6 w-full", className)}
      style={style}
    >
      {children}
    </Container>
  );
}
